var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"to":"/"}},[_c('b-img',{style:('width: ' + _vm.width),attrs:{"src":_vm.appLogoImage,"alt":"Indetec campus virtual"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }